export const HIGHLIGHT_TOOL_CONTROL_SIZES = {
	SM: 'sm',
	MD: 'md',
	LG: 'lg',
};

export const HIGHLIGHT_TOOL_CONTROL_SIZES_CONFIG = {
	[HIGHLIGHT_TOOL_CONTROL_SIZES.SM]: { min: 0, max: 629 },
	[HIGHLIGHT_TOOL_CONTROL_SIZES.MD]: { min: 630, max: 1023 },
	[HIGHLIGHT_TOOL_CONTROL_SIZES.LG]: { min: 1024, max: Infinity },
};
